// extracted by mini-css-extract-plugin
export default {"container":"overView_container__P3vmC","img":"overView_img__KoEjk","infoContainer":"overView_infoContainer__xZ9iC"};